import { render } from "./ResetFilter.vue?vue&type=template&id=24092fc4"
import script from "./ResetFilter.vue?vue&type=script&lang=js"
export * from "./ResetFilter.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__